export enum SERVICE_USER_STATUS {
  ACTIVE = 'ACTIVE',
  INVITATION_SENT = 'INVITATION_SENT',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
}
